const Profile = () => {
  return (
    <div className="px-2">
      <div className="max-w-screen-lg bg-[#5E5144] p-8 rounded-2xl flex flex-col gap-6 justify-center items-center">
        <div className="w-full flex max-lg:flex-col max-lg:items-center justify-between items-start gap-8">
          <img
            src="/img/oble_reed/avatar_3.webp"
            className="w-32 h-32 rounded-full object-cover object-center flex-shrink-0"
            alt="Cover"
          />
          <div className="flex-grow">
            <div className="space-y-3">
              <div className="flex justify-between">
                <div className="flex flex-col gap-1">
                  <div className="font-medium text-lg">Serena James</div>
                  <div className="flex justify-start items-center gap-1 text-gray-200">
                    <svg
                      width="25"
                      height="21"
                      viewBox="0 0 25 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.6326 9.00409e-05H20.5077V2.3438C20.5077 2.56951 20.4632 2.793 20.3769 3.00153C20.2905 3.21005 20.1639 3.39953 20.0043 3.55912C19.8447 3.71872 19.6552 3.84532 19.4467 3.93169C19.2382 4.01807 19.0147 4.06252 18.789 4.06252C18.5633 4.06252 18.3398 4.01807 18.1312 3.93169C17.9227 3.84532 17.7332 3.71872 17.5736 3.55912C17.414 3.39953 17.2874 3.21005 17.2011 3.00153C17.1147 2.793 17.0702 2.56951 17.0702 2.3438V9.00409e-05H7.96882V2.3438C7.96882 2.79964 7.78774 3.2368 7.46542 3.55912C7.1431 3.88145 6.70593 4.06252 6.2501 4.06252C5.79427 4.06252 5.3571 3.88145 5.03478 3.55912C4.71246 3.2368 4.53138 2.79964 4.53138 2.3438V9.00409e-05H1.40643C1.22051 -0.00202565 1.03606 0.0331627 0.863979 0.103574C0.691899 0.173986 0.535686 0.278191 0.40458 0.410026C0.273473 0.54186 0.170136 0.698648 0.100678 0.871116C0.0312213 1.04358 -0.00294484 1.22823 0.000200818 1.41413V18.8982C-0.00290305 19.0808 0.0300004 19.2623 0.0970318 19.4322C0.164063 19.6021 0.263909 19.7571 0.390868 19.8885C0.517826 20.0198 0.669408 20.1248 0.836958 20.1975C1.00451 20.2702 1.18474 20.3092 1.36737 20.3123H23.6326C23.8153 20.3092 23.9955 20.2702 24.163 20.1975C24.3306 20.1248 24.4822 20.0198 24.6091 19.8885C24.7361 19.7571 24.8359 19.6021 24.903 19.4322C24.97 19.2623 25.0029 19.0808 24.9998 18.8982V1.41413C25.0029 1.23151 24.97 1.05006 24.903 0.880155C24.8359 0.71025 24.7361 0.555215 24.6091 0.423904C24.4822 0.292593 24.3306 0.187579 24.163 0.11486C23.9955 0.0421411 23.8153 0.00314203 23.6326 9.00409e-05ZM6.2501 15.6248H4.68763V14.0624H6.2501V15.6248ZM6.2501 11.7187H4.68763V10.1562H6.2501V11.7187ZM6.2501 7.81247H4.68763V6.24999H6.2501V7.81247ZM10.9375 15.6248H9.37505V14.0624H10.9375V15.6248ZM10.9375 11.7187H9.37505V10.1562H10.9375V11.7187ZM10.9375 7.81247H9.37505V6.24999H10.9375V7.81247ZM15.6249 15.6248H14.0625V14.0624H15.6249V15.6248ZM15.6249 11.7187H14.0625V10.1562H15.6249V11.7187ZM15.6249 7.81247H14.0625V6.24999H15.6249V7.81247ZM20.3124 15.6248H18.7499V14.0624H20.3124V15.6248ZM20.3124 11.7187H18.7499V10.1562H20.3124V11.7187ZM20.3124 7.81247H18.7499V6.24999H20.3124V7.81247Z"
                        fill="white"
                      />
                    </svg>
                    <span>Joined: May 2024</span>
                  </div>
                </div>
                <div className="flex justify-end gap-6 text-gray-200">
                  <div className="flex flex-col gap-2 items-center">
                    <span>Following</span>
                    <span>0</span>
                  </div>
                  <div className="flex flex-col gap-2 items-center">
                    <span>Followers</span>
                    <span>0</span>
                  </div>
                </div>
              </div>
              <p className="text-gray-200">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                <br />
                Nullam fermentum tempor mauris sed porttitor. 
              </p>
            </div>
          </div>
        </div>
        <button className="px-8 py-1 rounded-2xl bg-white text-black font-bold">
          Follow
        </button>
      </div>
    </div>
  );
};

export default Profile;
